import { MARQUEE_ITEMS } from "@/content";

function Strip({ hidden = false }) {
  return (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {MARQUEE_ITEMS.map((item) => (
        <span key={item} className="flex items-center shrink-0">
          <span className="font-display text-lg sm:text-2xl font-bold uppercase tracking-wide text-white/90 px-6 sm:px-10 whitespace-nowrap">
            {item}
          </span>
          <span className="h-2.5 w-2.5 rounded-full bg-brand-orange shrink-0" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section data-testid="marquee-band" className="relative bg-brand-ink py-7 overflow-hidden grain">
      <div className="flex w-max animate-marquee mask-fade-x hover:[animation-play-state:paused]">
        <Strip />
        <Strip hidden />
      </div>
    </section>
  );
}
